'use strict';

const Listing = require('../models/inventory/Listing');

/**
 * Extract statuses from a list of listings.
 * @returns {Array}
 */
const getListingStatuses = (listings) => {
    const collection = listings.get('documents');

    if (collection) {
        return collection.map(listing => {
            return listing.get('status');
        });
    } else {
        return [];
    }
};

/**
 * Using a priority of statuses and an item's listing statuses (there could be multiple),
 * determine one status we want to use for display.
 * @param statuses - List of statuses based on item's metadata or listings document list.
 * @returns {string}
 */
const combinedListingStatus = (statuses) => {
    let status;
    if (statuses.indexOf(Listing.STATUS.NEW) >= 0 || statuses.indexOf(Listing.STATUS.COMPLETE) >= 0) {
        status = Listing.STATUS.COMPLETE;
    } else if (statuses.indexOf(Listing.STATUS.QUEUED) >= 0) {
        status = Listing.STATUS.QUEUED;
    } else if (statuses.indexOf(Listing.STATUS.PUBLISHED) >= 0) {
        status = Listing.STATUS.PUBLISHED;
    }
    return status;
};

const isSubmitted = (code) => {
    return [Listing.STATUS.NEW, Listing.STATUS.COMPLETE].indexOf(code) > -1;
};
const isQueued = (code) => {
    return Listing.STATUS.QUEUED === code;
};
const isPublished = (code) => {
    return Listing.STATUS.PUBLISHED === code;
};
/**
 * A method to get a display name key for your item. Display names tell you the general state of the item, like sold
 * or published, but they are not to be used for persistence. Basically they are read-only values describing your
 * item's state.
 * @param itemModel - the item model to get a status off of. The item model must have item listings metadata inflated
 *      Use the ITEM_LISTINGS_META_DATA field to get from listings core.
 * @param options - options for output
 *      pretty <boolean> pretty print output vs. camel-case values.
 * @returns {string}
 */
const getStatus = function (itemModel, options) {
    options = options || {};
    const listings = itemModel.getListings();
    if (itemModel.isSold()) {
        return 'sold';

    } else if (itemModel.isOnHoldForEverybody()) {
        return 'hold';

    } else if (itemModel.isOnHoldForCustomer()) {
        return 'holdForCustomer';

    } else if (itemModel.isRejected()) {
        return 'rejected';

    } else if (itemModel.isIncompleteStatus()) {
        return 'wip';

    } else if (itemModel.isCompleteStatus()) {
        const featuredMetadata = listings.getTypeMetadata(Listing.TYPE.FEATURED);
        const marketplaceMetadata = listings.getTypeMetadata(Listing.TYPE.MARKETPLACE);
        const storefrontMetadata = listings.getTypeMetadata(Listing.TYPE.STOREFRONT);

        const featured = combinedListingStatus(featuredMetadata.length ? featuredMetadata : getListingStatuses(listings.filterFeatured()));
        const marketplace = combinedListingStatus(marketplaceMetadata.length ? marketplaceMetadata : getListingStatuses(listings.filterMarketplace()));
        const storefront = combinedListingStatus(storefrontMetadata.length ? storefrontMetadata : getListingStatuses(listings.filterStorefront()));

        // order is important.  submitted || queued || published || featured || marketplace || storefront
        if (isSubmitted(featured)) {
            return 'submitted-featured';
        } else if (isQueued(featured)) {
            return 'queued-featured';
        } else if (isSubmitted(marketplace)) {
            return 'submitted-marketplace';
        } else if (isQueued(marketplace)) {
            return 'queued-marketplace';
        } else if (isPublished(featured)) {
            return 'featured';
        } else if (isPublished(marketplace)) {
            return 'marketplace';
        } else if (isPublished(storefront)) {
            return 'storefront';
        } else if (itemModel.isNotListed()) {
            return 'notListed';
        }
    } else if (itemModel.isDeletedStatus()) {
        return 'deleted';
    }

};

const pretty = function (str) {
    if (str === 'wip') {
        return 'Work In Progress';
    }
    str = str.replace(/([A-Z])/g, ' $1');
    return str.charAt(0).toUpperCase() + str.slice(1);
};

const output = function (itemModel, options) {
    const itemStatus = getStatus(itemModel, options);
    return (itemStatus && options && options.pretty === true) ? pretty(itemStatus) : itemStatus;
};

module.exports = output;



// WEBPACK FOOTER //
// ./~/bunsen/helpers/itemDisplayStatus.es.js